import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button as BaseButton, Dropdown, Menu } from '@bijie/react-bnb';
import { gwGet } from '../../../actions/actionsFactory/gwRequest';
import { setGetParams, handleGwData } from '../../../actions/actionsFactory';
import API_PATH from '../../../actions/actionsFactory/apiPath';
import { COLORS } from '../styles';
import { Link } from '../../../routes';
import { getLabelWithDefaultStr } from '../../../utils/i18n';

const { MenuItem: BaseMenuItem } = Menu;

export const Button = styled(BaseButton).attrs(({ size, type }) => ({
  size,
  type,
}))`
  width: ${({ width }) => width && `${width}px`};
  &:first-child {
    margin-right: 16px;
  }
`;

const MenuItem = styled(BaseMenuItem)`
  &&:hover {
    background-color: rgba(234, 236, 239, 0.3);
  }

  &:hover a {
    color: ${COLORS.yellow};
  }
`;

const A = styled.a`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.black};
`;

type DepositButtonProps = {
  i18n: Object,
  locale: string,
  coin: string,
  size: string,
  width: number,
  type: string,
};

type TradeButtonProps = {
  i18n: Object,
  locale: string,
  baseAsset: string,
  size: string,
  width: number,
  type: string,
};

export const DepositButton = ({
  i18n, locale, coin, type, size, width,
}: DepositButtonProps) => (
  <Link route={`/${locale}/usercenter/wallet/deposit/${coin}`}>
    <Button size={size} width={width} type={type}>
      {getLabelWithDefaultStr('exchange-staking-deposit-button', i18n, '充值')}
    </Button>
  </Link>
);

export const TradeButton = ({
  i18n, locale, baseAsset, size, width, type,
}: TradeButtonProps) => {
  const [tradePairs, setPairs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await gwGet(
        `${API_PATH.GET_SYMBOL_BY_ASSET_API_PATH}?${setGetParams({ baseAsset })}`
      );
      setPairs(handleGwData(result));
    };
    fetchData();
  }, [baseAsset]);

  return (
    <Dropdown
      overlay={
        <Menu
          mode="inline"
          style={{
            visibility: tradePairs ? 'visible' : 'hidden',
          }}
        >
          {tradePairs &&
            tradePairs.map(({ baseAsset: base, quoteAsset: quote }) => (
              <MenuItem key={quote}>
                <Link route={`/${locale}/trade/${base}_${quote}`}>
                  <A>{`${base}/${quote}`}</A>
                </Link>
              </MenuItem>
            ))}
        </Menu>
      }
    >
      <Button outline={true} size={size} disabled={!tradePairs} width={width} type={type}>
        {getLabelWithDefaultStr('exchange-staking-go-to-trade', i18n, '去交易')}
      </Button>
    </Dropdown>
  );
};
